import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-grid-text-with-image',
  templateUrl: './grid-text-with-image.component.html',
  styleUrls: ['./grid-text-with-image.component.css'],
})
export class GridTextWithImageComponent implements OnInit {
  @Input() data!: any;
  @Input() language!: any;
  @Input() fileName!: string;

  @ViewChild('carouselTrack') carouselTrack!: ElementRef<HTMLElement>;

  activeIndex = 0;
  isMobile = false;
  private touchStartX = 0;
  total = this.data?.details?.services?.length ?? 0;

  ngOnInit(): void {
    this.checkMobile();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkMobile();
  }

  checkMobile(): void {
    this.isMobile = window.innerWidth <= 767;
  }

  goToSlide(index: number): void {
    this.activeIndex = index;
    const track = this.carouselTrack?.nativeElement;
    if (!track) return;

    const slide = track.querySelector('.carousel-slide') as HTMLElement;
    if (!slide) return;

    const slideWidth = slide.offsetWidth + 12; // 12px gap
    track.style.transition = 'transform 0.35s ease';
    // Positive value for RTL (Arabic) layouts
    track.style.transform = `translateX(${index * slideWidth}px)`;
  }

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.touches[0].clientX;
  }

  onTouchMove(event: TouchEvent): void {
    const diff = this.touchStartX - event.touches[0].clientX;
    const track = this.carouselTrack?.nativeElement;
    if (!track) return;

    const slide = track.querySelector('.carousel-slide') as HTMLElement;
    if (!slide) return;

    const slideWidth = slide.offsetWidth + 12;
    const base = this.activeIndex * slideWidth;

    track.style.transition = 'none';
    // Positive base for RTL — finger follows drag naturally
    track.style.transform = `translateX(${base - diff}px)`;
  }

  onTouchEnd(event: TouchEvent): void {
    const track = this.carouselTrack?.nativeElement;
    if (track) track.style.transition = 'transform 0.35s ease';

    const diff = this.touchStartX - event.changedTouches[0].clientX;
    const total = this.data?.services?.length ?? 0; // ← data.services not data.details.services

    if (Math.abs(diff) > 40) {
      if (diff < 0 && this.activeIndex < total - 1) {
        // Swiped right (RTL) → next slide
        this.goToSlide(this.activeIndex + 1);
      } else if (diff > 0 && this.activeIndex > 0) {
        // Swiped left (RTL) → previous slide
        this.goToSlide(this.activeIndex - 1);
      } else {
        this.goToSlide(this.activeIndex); // boundary snap-back
      }
    } else {
      this.goToSlide(this.activeIndex); // not far enough — snap back
    }
  }
}
